import { render, staticRenderFns } from "./HeaderMenu.vue?vue&type=template&id=1b8f9b27&scoped=true"
import script from "./HeaderMenu.vue?vue&type=script&lang=js"
export * from "./HeaderMenu.vue?vue&type=script&lang=js"
import style0 from "./HeaderMenu.vue?vue&type=style&index=0&id=1b8f9b27&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8f9b27",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b8f9b27')) {
      api.createRecord('1b8f9b27', component.options)
    } else {
      api.reload('1b8f9b27', component.options)
    }
    module.hot.accept("./HeaderMenu.vue?vue&type=template&id=1b8f9b27&scoped=true", function () {
      api.rerender('1b8f9b27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/HeaderMenu.vue"
export default component.exports